<template>
  <div>
    <router-view></router-view>
    <PageHeaderLayout v-show="this.$route.matched.length==2">
      <div class="main-page-content">
        <!-- 页面标题区域 -->
        <div class="page-title-section">
          <div class="title-content">
            <h1 class="page-title">
              <i class="el-icon-box"></i>
              材料管理
            </h1>
            <p class="page-subtitle">管理工艺分类下的材料信息，包括材料属性、价格、工期等配置</p>
          </div>
        </div>

        <!-- 操作按钮卡片 -->
        <div class="action-card">
          <div class="action-header">
            <h3 class="action-title">
              <i class="el-icon-s-tools"></i>
              操作面板
            </h3>
          </div>
          <div class="action-buttons">
            <el-button type="primary" size="mini" icon="el-icon-upload2" @click="triggerFileUpload" :disabled="loadingStaus" class="action-btn">
              导入材料
            </el-button>
            <input type="file" accept=".xlsx" ref="fileInput" @change="importExcel" style="display: none;" />
            <el-button type="success" size="mini" icon="el-icon-download" @click="downloadButton()" class="action-btn">
              导出材料
            </el-button>
            <el-tooltip effect="dark" content="添加材料" placement="top-start">
              <el-button type="primary" size="mini" icon="el-icon-plus" @click="addButton()" class="action-btn">
                添加材料
              </el-button>
            </el-tooltip>
            <el-button type="primary" size="mini" v-if="userPermissions.indexOf('material_add') != -1 && buttonType=='text'" @click="addButton()" class="action-btn">
              <i class="el-icon-plus"></i>
              添加
            </el-button>
          </div>
        </div>

        <!-- 搜索筛选卡片 -->
        <div class="search-card">
          <div class="search-header">
            <h3 class="search-title">
              <i class="el-icon-search"></i>
              搜索筛选
            </h3>
            <p class="search-subtitle">根据材料名称、类型、密度、单价等条件筛选材料</p>
          </div>
          <el-form size="mini" :inline="true" :model="searchCondition" class="search-form">
            <el-form-item label="材料名称">
              <el-input 
                v-model="searchCondition.material_name" 
                placeholder="请输入材料名称" 
                clearable
                prefix-icon="el-icon-box">
              </el-input>
            </el-form-item>
            <el-form-item label="材料密度">
              <el-input 
                v-model="searchCondition.material_density" 
                placeholder="请输入密度" 
                clearable
                prefix-icon="el-icon-s-data">
              </el-input>
            </el-form-item>
            <el-form-item label="材料单价">
              <el-input 
                v-model="searchCondition.material_unit_price" 
                placeholder="请输入单价" 
                clearable
                prefix-icon="el-icon-money">
              </el-input>
            </el-form-item>
            <el-form-item label="材料类型">
              <el-select v-model="searchCondition.material_type" placeholder="请选择材料类型" clearable>
                <el-option label="🔧 金属" value="1"></el-option>
                <el-option label="🧪 树脂" value="2"></el-option>
                <el-option label="🔩 尼龙" value="3"></el-option>
                <el-option label="🎨 塑料" value="4"></el-option>
                <el-option label="🔨 复模材料" value="5"></el-option>
                <el-option label="⚛️ Micronano" value="6"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="getMaterials" class="search-btn">
                <i class="el-icon-search"></i>
                查询
              </el-button>
              <el-button @click="resetSearch" class="reset-btn">
                <i class="el-icon-refresh"></i>
                重置
              </el-button>
            </el-form-item>
          </el-form>
        </div>

        <!-- 表格卡片 -->
        <div class="table-card">
          <div class="table-header">
            <div class="header-left">
              <i class="el-icon-box"></i>
              <span>材料列表</span>
            </div>
            <div class="header-right">
              <el-tag type="info" size="mini">
                <i class="el-icon-info"></i>
                共 {{pagingData.total}} 条记录
              </el-tag>
            </div>
          </div>
        <ApeTable ref="apeTable" :data="dataList" :loading="loadingStaus" :pagingData="pagingData" @switchPaging="switchPaging" highlight-current-row>
            <el-table-column width="80" align="center" label="排序">
              <template slot-scope="scope">
                <el-tooltip effect="dark" content="拖动排序" placement="top-start">
                  <span class="drag-handle" :data-id="scope.row.id" :data-parent_id="scope.row.pid" :data-depth="scope.row.depth">
                    <i class="el-icon-rank"></i>
                  </span>
                </el-tooltip>
              </template>
          </el-table-column>
            <el-table-column width="64" label="序号">
            <template slot-scope="scope">
                <el-tag size="mini" type="info">{{offset+scope.$index+1}}</el-tag>
            </template>
          </el-table-column>
            <el-table-column width="120" label="材料图片">
            <template slot-scope="scope">
                <div class="material-image">
                  <img :src="getallUrl(scope.row.material_pic)" style="width: 64px; height:64px; border-radius: 8px; object-fit: cover;">
                  <div class="image-overlay">
                    <i class="el-icon-view"></i>
                  </div>
                </div>
            </template>
          </el-table-column>
            <el-table-column label="材料信息" min-width="200">
            <template slot-scope="scope">
                <div class="material-info">
                  <div class="info-row">
                    <i class="el-icon-box"></i>
                    <span class="info-label">名称：</span>
                    <span class="info-value">{{scope.row.material_name}}</span>
                  </div>
                  <div class="info-row">
                    <i class="el-icon-files"></i>
                    <span class="info-label">类型：</span>
                    <el-tag :type="getMaterialTypeColor(scope.row.material_type)" size="mini">
                      {{getMaterialTypeName(scope.row.material_type)}}
                    </el-tag>
                  </div>
                  <div class="info-row">
                    <i class="el-icon-s-data"></i>
                    <span class="info-label">密度：</span>
                    <span class="info-value">{{scope.row.material_density}}</span>
                  </div>
                  <div class="info-row">
                    <i class="el-icon-s-operation"></i>
                    <span class="info-label">使用系数：</span>
                    <el-tag :type="scope.row.material_use_coefficient==1?'success':'info'" size="mini">
                      {{scope.row.material_use_coefficient==1?'是':'否'}}
                    </el-tag>
                  </div>
                </div>
            </template>
          </el-table-column>
            <el-table-column label="价格信息" min-width="180">
            <template slot-scope="scope">
                <div class="material-info">
                  <div class="info-row">
                    <i class="el-icon-money"></i>
                    <span class="info-label">材料单价：</span>
                    <span class="info-value price-text">{{scope.row.material_unit_price}}元/kg</span>
                  </div>
                  <div class="info-row" v-if="scope.row.material_type==5">
                    <i class="el-icon-brush"></i>
                    <span class="info-label">打磨单价：</span>
                    <span class="info-value price-text">{{scope.row.material_polishing_price}}元/kg</span>
                  </div>
                  <div class="info-row">
                    <i class="el-icon-ruler"></i>
                    <span class="info-label">保底尺寸：</span>
                    <span class="info-value">{{scope.row.material_small_longest_side}}mm</span>
                  </div>
                  <div class="info-row">
                    <i class="el-icon-coin"></i>
                    <span class="info-label">保底价格：</span>
                    <span class="info-value price-text">{{scope.row.material_small_longest_side_price}}元</span>
                  </div>
                </div>
            </template>
          </el-table-column>
            <el-table-column label="详细信息" min-width="200">
            <template slot-scope="scope">
                <div class="material-info">
                  <div class="info-row">
                    <i class="el-icon-price-tag"></i>
                    <span class="info-label">标签：</span>
                    <span class="info-value">{{scope.row.material_label}}</span>
                  </div>
                  <div class="info-row">
                    <i class="el-icon-star-on"></i>
                    <span class="info-label">优点：</span>
                    <span class="info-value">{{scope.row.material_advantage}}</span>
                  </div>
                  <div class="info-row">
                    <i class="el-icon-document"></i>
                    <span class="info-label">描述：</span>
                    <el-tooltip :content="scope.row.material_desc" placement="top" :disabled="!scope.row.material_desc || scope.row.material_desc.length <= 20">
                      <span class="info-value">{{scope.row.material_desc | truncate(20)}}</span>
                    </el-tooltip>
                  </div>
                </div>
            </template>
          </el-table-column>
            <el-table-column label="尺寸规格" min-width="180">
            <template slot-scope="scope">
                <div class="material-info">
                  <div class="info-row">
                    <i class="el-icon-full-screen"></i>
                    <span class="info-label">最大尺寸：</span>
                    <span class="info-value">{{scope.row.material_max_size}}</span>
                  </div>
                  <div class="info-row">
                    <i class="el-icon-aim"></i>
                    <span class="info-label">材料公差：</span>
                    <span class="info-value">{{scope.row.tolerance_precision}}</span>
                  </div>
                  <div class="info-row" v-if="scope.row.material_attachment">
                    <i class="el-icon-paperclip"></i>
                    <span class="info-label">材料附件：</span>
                    <el-button type="text" size="mini" @click="window.open(getallUrl(scope.row.material_attachment))">
                      <i class="el-icon-download"></i>
                      下载
                    </el-button>
                  </div>
                </div>
            </template>
          </el-table-column>
            <el-table-column label="状态" width="80" align="center">
            <template slot-scope="scope">
                <div class="status-column">
                  <div class="status-item">
                    <span class="status-label">启用</span>
                    <el-switch 
                      v-model="scope.row.material_status" 
                      :active-value="'1'" 
                      :inactive-value="'0'" 
                      active-color="#13ce66" 
                      inactive-color="#ff4949" 
                      @change="changeStatus(scope.row)">
                    </el-switch>
                  </div>
                  <div class="status-item">
                    <span class="status-label">推荐</span>
                    <el-switch 
                      v-model="scope.row.material_recommend" 
                      :active-value="'1'" 
                      :inactive-value="'0'" 
                      active-color="#13ce66" 
                      inactive-color="#ff4949" 
                      @change="changeStatus(scope.row)">
                    </el-switch>
                  </div>
                </div>
            </template>
          </el-table-column>
            <el-table-column v-if="buttonType=='icon'" width="260" label="操作" align="center">
            <template slot-scope="scope">
                <div class="action-buttons">
                  <el-tooltip effect="dark" content="编辑材料" placement="top">
                    <el-button size="mini" type="primary" icon="el-icon-edit" @click="editButton(scope.row.id)" class="action-btn-mini"></el-button>
              </el-tooltip>
                  <el-tooltip effect="dark" content="材料颜色" placement="top">
                    <el-button size="mini" type="warning" icon="el-icon-brush" @click="getMaterialColor(scope.row.id)" class="action-btn-mini"></el-button>
              </el-tooltip>
                  <el-tooltip effect="dark" content="材料工期" placement="top">
                    <el-button size="mini" type="success" icon="el-icon-time" @click="getMaterialDuration(scope.row.id)" class="action-btn-mini"></el-button>
              </el-tooltip>
                  <el-tooltip effect="dark" content="后处理工艺" placement="top">
                    <el-button size="mini" type="info" icon="el-icon-guide" @click="getMaterialFollowCraft(scope.row.id)" class="action-btn-mini"></el-button>
              </el-tooltip>
                </div>
            </template>
          </el-table-column>
        </ApeTable>
        </div>
      </div>
    </PageHeaderLayout>

    <ApeDrawer :drawerData="drawerData"  @drawerClose="drawerClose" @drawerConfirm="drawerConfirm">
      <template slot="ape-drawer">
        <div class="form-container">
          <el-form :model="formData" :rules="rules" ref="dataForm" label-position="right" label-width="120px" class="material-form">
            
            <!-- 基础信息区域 -->
            <div class="form-section">
              <div class="section-header">
                <h3 class="section-title">
                  <i class="el-icon-box"></i>
                  基础信息
                </h3>
              </div>
              <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="材料名称" prop="material_name">
                    <el-input v-model="formData.material_name" placeholder="请输入材料名称">
                      <i slot="prefix" class="el-input__icon el-icon-box"></i>
                    </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="材料类型" prop="material_type">
                    <el-select v-model="formData.material_type" placeholder="请选择材料类型" style="width: 100%">
                      <el-option label="🔧 金属" value="1"></el-option>
                      <el-option label="🧪 树脂" value="2"></el-option>
                      <el-option label="🔩 尼龙" value="3"></el-option>
                      <el-option label="🎨 塑料" value="4"></el-option>
                      <el-option label="🔨 复模材料" value="5"></el-option>
                      <el-option label="⚛️ Micronano" value="6"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="材料密度" prop="material_density">
                    <el-input v-model="formData.material_density" type="number" placeholder="请输入材料密度">
                      <i slot="prefix" class="el-input__icon el-icon-s-data"></i>
                      <template slot="append">g/cm³</template>
                    </el-input>
              </el-form-item>
            </el-col>
                <el-col :span="6">
                  <el-form-item label="材料公差" prop="tolerance_precision">
                    <el-input v-model="formData.tolerance_precision" placeholder="请输入材料公差">
                      <i slot="prefix" class="el-input__icon el-icon-aim"></i>
                      <template slot="append">mm</template>
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>

            <!-- 价格信息区域 -->
            <div class="form-section">
              <div class="section-header">
                <h3 class="section-title">
                  <i class="el-icon-money"></i>
                  价格信息
                </h3>
              </div>
              <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="材料单价" prop="material_unit_price">
                    <el-input v-model="formData.material_unit_price" type="number" placeholder="请输入材料单价">
                      <i slot="prefix" class="el-input__icon el-icon-money"></i>
                      <template slot="append">元/g</template>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6" v-if="formData.material_type==5">
                  <el-form-item label="打磨单价" prop="material_polishing_price">
                    <el-input v-model="formData.material_polishing_price" type="number" placeholder="请输入打磨单价">
                      <i slot="prefix" class="el-input__icon el-icon-brush"></i>
                      <template slot="append">元/g</template>
                    </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
                  <el-form-item label="保底尺寸" prop="material_small_longest_side">
                    <el-input v-model="formData.material_small_longest_side" type="number" placeholder="保底尺寸">
                      <i slot="prefix" class="el-input__icon el-icon-ruler"></i>
                      <template slot="append">mm</template>
                    </el-input>
              </el-form-item>
            </el-col>
                <el-col :span="6">
                  <el-form-item label="保底价格" prop="material_small_longest_side_price">
                    <el-input v-model="formData.material_small_longest_side_price" type="number" placeholder="保底价格">
                      <i slot="prefix" class="el-input__icon el-icon-coin"></i>
                      <template slot="append">元</template>
                    </el-input>
              </el-form-item>
                </el-col>
              </el-row>
            </div>

            <!-- 配置信息区域 -->
            <div class="form-section">
              <div class="section-header">
                <h3 class="section-title">
                  <i class="el-icon-s-tools"></i>
                  配置信息
                </h3>
              </div>
              <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="使用材料系数" prop="material_use_coefficient">
                    <el-select v-model="formData.material_use_coefficient" placeholder="请选择" style="width: 100%" @change="changeUseCoefficient">
                      <el-option label="✅ 是" value="1"></el-option>
                      <el-option label="❌ 否" value="0"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
                  <el-form-item label="启用状态" prop="material_status">
                    <el-select v-model="formData.material_status" placeholder="请选择" style="width: 100%">
                      <el-option label="✅ 启用" value="1"></el-option>
                      <el-option label="❌ 禁用" value="0"></el-option>
              </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
                  <el-form-item label="推荐状态" prop="material_recommend">
                    <el-select v-model="formData.material_recommend" placeholder="请选择" style="width: 100%">
                      <el-option label="⭐ 推荐" value="1"></el-option>
                      <el-option label="🔘 不推荐" value="0"></el-option>
              </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="最大尺寸" prop="material_max_size">
                    <el-input v-model="formData.material_max_size" placeholder="请输入最大尺寸">
                      <i slot="prefix" class="el-input__icon el-icon-full-screen"></i>
                    </el-input>
              </el-form-item>
            </el-col>
              </el-row>
            </div>

            <!-- 详细描述区域 -->
            <div class="form-section">
              <div class="section-header">
                <h3 class="section-title">
                  <i class="el-icon-document"></i>
                  详细描述
                </h3>
              </div>
              <el-row :gutter="20">
                <el-col :span="12">
              <el-form-item label="材料标签" prop="material_label">
                    <el-input v-model="formData.material_label" type="textarea" :rows="4" placeholder="请输入材料标签"></el-input>
              </el-form-item>
            </el-col>
                <el-col :span="12">
              <el-form-item label="材料优点" prop="material_advantage">
                    <el-input v-model="formData.material_advantage" type="textarea" :rows="4" placeholder="请输入材料优点"></el-input>
              </el-form-item>
            </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="24">
              <el-form-item label="材料描述" prop="material_desc">
                    <el-input v-model="formData.material_desc" type="textarea" :rows="4" placeholder="请输入详细的材料描述"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
            </div>

            <!-- 材料系数配置 -->
            <div class="form-section" v-if="formData.material_use_coefficient=='1'">
              <div class="section-header">
                <h3 class="section-title">
                  <i class="el-icon-s-operation"></i>
                  材料系数配置
                </h3>
              </div>
          <el-row>
                <el-col :span="24">  
                  <el-form-item label="系数配置" prop="material_coefficient_config">
                                         <div class="coefficient-config-section">
                       <div class="config-header">
                         <span>系数配置表</span>
                         <el-button type="primary" size="mini" icon="el-icon-plus" @click="addCoefficientRow" class="add-row-btn">
                           添加配置
                         </el-button>
                       </div>
                       <el-table :data="formData.material_coefficient_config" style="width: 100%" class="coefficient-table">
                         <el-table-column label="最小长度" prop="min_length" width="150">
                           <template slot-scope="scope">
                             <el-input v-model="scope.row.min_length" placeholder="最小长度" size="mini">
                               <i slot="prefix" class="el-input__icon el-icon-ruler"></i>
                               <template slot="append">mm</template>
                             </el-input>
                           </template>
                         </el-table-column>
                         <el-table-column label="最大长度" prop="max_length" width="150">
                           <template slot-scope="scope">
                             <el-input v-model="scope.row.max_length" placeholder="最大长度" size="mini">
                               <i slot="prefix" class="el-input__icon el-icon-ruler"></i>
                               <template slot="append">mm</template>
                             </el-input>
                           </template>
                         </el-table-column>
                         <el-table-column label="系数" prop="coefficient" width="120">
                           <template slot-scope="scope">
                             <el-input v-model="scope.row.coefficient" placeholder="系数" size="mini">
                               <i slot="prefix" class="el-input__icon el-icon-s-operation"></i>
                             </el-input>
                           </template>
                         </el-table-column>
                         <el-table-column label="操作" width="80" align="center">
                           <template slot-scope="scope">
                             <el-button type="danger" size="mini" icon="el-icon-delete" @click="deleteCoefficientRow(scope.$index)" class="delete-row-btn"></el-button>
                           </template>
                         </el-table-column>
                       </el-table>
                     </div>
              </el-form-item>
            </el-col>
          </el-row>
            </div>

            <!-- 文件上传区域 -->
            <div class="form-section">
              <div class="section-header">
                <h3 class="section-title">
                  <i class="el-icon-upload"></i>
                  文件上传
                </h3>
              </div>
              <el-row :gutter="20">
                <el-col :span="12">
              <el-form-item label="材料图片"> 
                    <div class="upload-section">
                 <ApeUploader :limit="1" @handleUploadSuccess="handleUploadImageSuccess" @handleUploadRemove="handleUploadImageRemove" :upload-file-list="uploadImageList"></ApeUploader> 
                    </div>
              </el-form-item>
            </el-col>
                <el-col :span="12">
              <el-form-item label="材料附件"> 
                    <div class="upload-section">
                 <ApeUploader :limit="1" @handleUploadSuccess="handleUploadFileSuccess" @handleUploadRemove="handleUploadFileRemove" :upload-file-list="uploadFileList" :is-image="false"></ApeUploader> 
                    </div>
              </el-form-item>
            </el-col>
          </el-row>
            </div>

            <!-- 定制信息区域 -->
            <div class="form-section">
              <div class="section-header">
                <h3 class="section-title">
                  <i class="el-icon-s-custom"></i>
                  定制信息
                </h3>
                <el-button type="primary" size="mini" icon="el-icon-plus" @click="addItem" class="add-custom-btn">
                  添加定制信息
                </el-button>
              </div>
              <div class="custom-table-container">
                <el-table :data="formData.material_customize" stripe class="custom-table">
                  <el-table-column label="标题" min-width="200">
                <template slot-scope="scope">
                      <el-input v-model="scope.row.title" placeholder="请输入标题">
                        <i slot="prefix" class="el-input__icon el-icon-price-tag"></i>
                      </el-input>
                </template>
              </el-table-column>
                  <el-table-column label="内容" min-width="300">
                <template slot-scope="scope">
                      <el-input v-model="scope.row.content" type="textarea" :rows="3" placeholder="请输入内容"></el-input>
                </template>
              </el-table-column>
                  <el-table-column label="操作" width="80" align="center">
                <template slot-scope="scope">
                      <el-button type="danger" size="mini" icon="el-icon-delete" @click="deleteItem(scope.$index)" class="delete-btn"></el-button>
                </template>
              </el-table-column>
            </el-table> 
              </div>
            </div>
          <I18nTranslatePanel entity-type="craft_material" :entity-id="formData.id || ''" />
        </el-form>     
        </div>
      </template>
    </ApeDrawer>
  </div >
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import ApeTable from '@/components/ApeTable'
import ApeDrawer from '@/components/ApeDrawer'
import { mapGetters } from 'vuex'
import * as XLSX from 'xlsx';
import Sortable from 'sortablejs'
import ApeUploader from '@/components/ApeUploader'
import I18nTranslatePanel from '@/components/I18nTranslatePanel'
export default {
  components: {
    PageHeaderLayout,
    ApeTable,
    I18nTranslatePanel,
    ApeDrawer,
    ApeUploader
  },
  data() {
    return {
      // 搜索条件
      searchCondition:{
        current_page: 1,
        page_size: 20,
        material_name:'',
        material_type:'',
        material_density:'',
        material_unit_price:'',
        order_by: "material_rank asc",
        query: "",
        params: [],
      },
      textareaStyle: {
        width: '100%',
        height: '160px'
      },
 
      loadingStaus: true,
      // 表格列表数据
      dataList:[],
      // 分页信息
      pagingData:{
        is_show: true,
        page_size: 20,
        layout: 'total, sizes, prev, pager, next, jumper',
        total: 0
      },
      // 分页的offset,序号列使用
      offset:0,
      uploadFileList:[],
      uploadImageList:[],
      // 表单结构
      formData: {
        material_customize:[],
        id:0,
        material_use_coefficient:'0',
        material_status:'1',
        material_recommend:'0',
        material_coefficient_config:[],
        material_max_size:'',
        material_label:'',
        material_advantage:'',
        
      },
      // 表单验证
      rules: {
        material_name: [{required: true,message:'输入材料名称', trigger: 'blur' }],
      },
      opinions:[
        {
          label:'否',
          value:'0'
        },
        {
          label:'是',
          value:'1'
        }
      ],
      // 抽屉数据
      drawerData: {
        visible: false,
        loading: true,
        loading_text: '玩命加载中……',
        title: '权限绑定',
        width_height: '80%',
      },
    }
  },
  computed: {
    ...mapGetters(['userPermissions','buttonType'])
  },
  filters: {
    truncate(text, maxLength) {
      if (!text) return ''
      if (text.length <= maxLength) return text
      return text.substring(0, maxLength) + '...'
    }
  },
  methods: {
    // 获取材料类型名称
    getMaterialTypeName(type) {
      const typeMap = {
        '1': '🔧 金属',
        '2': '🧪 树脂', 
        '3': '🔩 尼龙',
        '4': '🎨 塑料',
        '5': '🔨 复模材料',
        '6': '⚛️ Micronano'
      }
      return typeMap[type] || '未知'
    },
    // 获取材料类型颜色
    getMaterialTypeColor(type) {
      const colorMap = {
        '1': 'primary',
        '2': 'success',
        '3': 'warning',
        '4': 'danger',
        '5': 'info',
        '6': ''
      }
      return colorMap[type] || 'info'
    },
         // 解析JSON字符串，处理转义字符
     parseJsonString(jsonStr) {
       try {
         if (!jsonStr || jsonStr === 'null' || jsonStr === '') {
           return []
         }
         
         let cleanStr = jsonStr.trim()
         // 处理多层引号嵌套的情况，如 "\"\\\"[]\\\"\""
         // 先移除最外层的引号
         while (cleanStr.startsWith('"') && cleanStr.endsWith('"')) {
           cleanStr = cleanStr.slice(1, -1)
         }
         
         // 处理转义字符 - 分步骤处理，避免相互干扰
         let prevStr = ''
         let iterations = 0
         while (cleanStr !== prevStr && iterations < 10) { // 增加迭代次数处理更复杂的转义
           prevStr = cleanStr
           
           // 先处理双重反斜杠
           cleanStr = cleanStr.replace(/\\\\/g, '\\')
           // 再处理转义引号
           cleanStr = cleanStr.replace(/\\"/g, '"')
           // 处理其他转义字符
           cleanStr = cleanStr.replace(/\\n/g, '\n')
           cleanStr = cleanStr.replace(/\\r/g, '\r')
           cleanStr = cleanStr.replace(/\\t/g, '\t')
           
           iterations++
         }
         
         // 特殊情况：如果是空数组或空对象字符串
         if (cleanStr === '[]' || cleanStr === '{}') {
           return JSON.parse(cleanStr)
         }
         
         // 如果字符串看起来像JSON但被引号包围，再次尝试移除引号
         if ((cleanStr.startsWith('"[') && cleanStr.endsWith(']"')) ||
             (cleanStr.startsWith('"{') && cleanStr.endsWith('}"'))) {
           cleanStr = cleanStr.slice(1, -1)
         }
         
         // 尝试解析
         const result = JSON.parse(cleanStr)
         return result
         
       } catch (error) {
         // 如果解析失败，尝试返回默认值
         if (jsonStr.includes('[]')) {
           return []
         }
         if (jsonStr.includes('{}')) {
           return []
         }
         // 特殊处理：如果字符串包含对象结构，尝试提取
         if (jsonStr.includes('{') && jsonStr.includes('}')) {
           try {
             // 尝试找到JSON对象的开始和结束
             const startIdx = jsonStr.indexOf('[')
             const endIdx = jsonStr.lastIndexOf(']')
             if (startIdx !== -1 && endIdx !== -1 && endIdx > startIdx) {
               const jsonPart = jsonStr.substring(startIdx, endIdx + 1)
               return JSON.parse(jsonPart)
             }
           } catch (e) {
             // 忽略错误，继续尝试其他方法
             console.log(e)
             return []
           }
         }
         return []
       }
     },
     changeUseCoefficient(){
       if(this.formData.material_use_coefficient=='1'){
         this.formData.material_coefficient_config =[
           {max_length:1,min_length:1,coefficient:1.0}]
       }else{
         this.formData.material_coefficient_config = []
       }
     },
     
     // 添加系数配置行
     addCoefficientRow() {
       this.formData.material_coefficient_config.push({
         min_length: '',
         max_length: '',
         coefficient: ''
       })
     },
     
     // 删除系数配置行
     deleteCoefficientRow(index) {
       this.formData.material_coefficient_config.splice(index, 1)
     },
    // 重置搜索
    resetSearch() {
      this.searchCondition = {
        current_page: 1,
        page_size: 20,
        material_name: '',
        material_type: '',
        material_density: '',
        material_unit_price: '',
        order_by: "material_rank asc",
        query: "",
        params: [],
      }
      this.getMaterials()
    },
    // 搜索
    setSearchCondition() {
      this.searchCondition.query= ''
      this.searchCondition.params = []
      this.searchCondition.query = "craft_category_id=?"
      this.searchCondition.params = [this.$route.params.id] 
      if(this.searchCondition.material_name != ""){
        this.searchCondition.query = this.searchCondition.query + " and instr(material_name,?)>0"
        this.searchCondition.params.push(this.searchCondition.material_name)
      }
      if (this.searchCondition.material_type != ''){
        this.searchCondition.query = this.searchCondition.query + " and material_type=?"
        this.searchCondition.params.push(this.searchCondition.material_type)
      }
      if (this.searchCondition.material_density != ''){
        this.searchCondition.query = this.searchCondition.query + " and material_density=?"
        this.searchCondition.params.push(this.searchCondition.material_density)
      }
      if (this.searchCondition.material_unit_price != ''){
        this.searchCondition.query = this.searchCondition.query + " and material_unit_price=?"
        this.searchCondition.params.push(this.searchCondition.material_unit_price)
      }
    },
    // 切换页码操作
    async switchPaging() {
      this.getMaterials()
    },
    async changeStatus(row){
       row.material_customize = JSON.stringify(row.material_customize)
       let res = await this.$api.post('/service/ola_app_craft_category_material/update',row)
       if (this.$apiSuccess(res)){
        this.$message.success('保存成功!')
        this.getMaterials()
       }else{
        this.$message.error(res.message)
       }
    },
    triggerFileUpload() {
      this.$refs.fileInput.click()
    },
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: 'array' });
          // 处理工作簿内容
          const firstSheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[firstSheetName];
          const jsonData = XLSX.utils.sheet_to_json(worksheet);
          this.importData(jsonData)
        };
        reader.readAsArrayBuffer(file);
      }
    },
    // 校验 Excel 材料分类ID：非空必须与当前 URL 分类一致；空则回填 URL id
    resolveImportCategoryId(excelCategoryId, materialName, rowIndex) {
      const urlId = String(this.$route.params.id || '').trim()
      const excelId = excelCategoryId == null ? '' : String(excelCategoryId).trim()
      if (!urlId) {
        return { ok: false, message: '当前页面缺少分类ID，无法导入' }
      }
      if (excelId && excelId !== urlId) {
        const name = materialName ? `「${materialName}」` : `第${rowIndex}行`
        return {
          ok: false,
          message: `材料${name}的分类ID（${excelId}）与当前页面分类（${urlId}）不一致，请修改后再导入`
        }
      }
      return { ok: true, craft_category_id: excelId || urlId }
    },
    buildImportDatas(jsonData) {
      const datas = []
      for (let i = 0; i < jsonData.length; i++) {
        const item = jsonData[i]
        const resolved = this.resolveImportCategoryId(item.材料分类ID, item.材料名称, i + 2)
        if (!resolved.ok) {
          return { ok: false, message: resolved.message }
        }
        datas.push({
          craft_category_id: resolved.craft_category_id,
          material_name: item.材料名称,
          material_pic: item.材料图片,
          material_density: item.材料密度,
          material_label: item.材料标签,
          material_desc: item.材料描述,
          material_type: item.材料类型,
          material_advantage: item.材料优点,
          material_max_size: item.最大尺寸,
          material_status: item.启用,
          material_recommend: item.推荐,
          material_polishing_price: item.打磨单价,
          material_unit_price: item.克重单价,
          material_base_price: item.材料单价,
          tolerance_precision: item.精度公差,
          material_attachment: item.材料附件,
          material_customize: item.定制信息,
          material_use_coefficient: item.使用材料系数,
          material_coefficient_config: item.材料系数配置,
          material_rank: item.排序,
          material_small_longest_side: item.保底尺寸,
          material_small_longest_side_price: item.保底价格
        })
      }
      return { ok: true, datas }
    },
    async importData(jsonData) {
      try {
        if (!jsonData || !jsonData.length) {
          this.$message.warning('导入文件没有有效数据行')
          return
        }
        const built = this.buildImportDatas(jsonData)
        if (!built.ok) {
          this.$message.error(built.message)
          return
        }
        let res = await this.$api.post('/service/ola_app_craft_category_material/import', {
          datas: built.datas,
          unique_key: 'craft_category_id,material_name'
        })
        if (this.$apiSuccess(res)) {
          this.$message.success('导入成功!')
          this.getMaterials()
        } else {
          this.$message.error(res.message || res.msg || '导入失败')
        }
      } finally {
        this.loadingStaus = false
        if (this.$refs.fileInput) {
          this.$refs.fileInput.value = ''
        }
      }
    },
    async importExcel() {
      this.loadingStaus = true
      const file = this.$refs.fileInput.files[0]
      if (!file) {
        this.$message.error('请先选择Excel文件')
        this.loadingStaus = false
        return
      }
      try {
        const buffer = await new Promise((resolve, reject) => {
          const reader = new FileReader()
          reader.onload = (e) => resolve(e.target.result)
          reader.onerror = () => reject(new Error('读取Excel失败'))
          reader.readAsArrayBuffer(file)
        })
        const workbook = XLSX.read(new Uint8Array(buffer), { type: 'array' })
        const firstSheetName = workbook.SheetNames[0]
        const worksheet = workbook.Sheets[firstSheetName]
        const jsonData = XLSX.utils.sheet_to_json(worksheet)
        // 先校验分类ID：不一致报错；为空则用当前 URL 分类ID 再入库
        await this.importData(jsonData)
      } catch (e) {
        this.$message.error('导入失败: ' + (e.message || e))
        this.loadingStaus = false
        if (this.$refs.fileInput) {
          this.$refs.fileInput.value = ''
        }
      }
    },
    async downloadButton() {
      let searchCondition = {query:'craft_category_id=?',params:[this.$route.params.id]}
      let res = await this.$api.post('/service/ola_app_craft_category_material/list',searchCondition)
      if (this.$apiSuccess(res)){
        let data = res.data.list
        const filteredData = data.map(item => ({
          "材料分类ID": item.craft_category_id,
          "材料名称": item.material_name,
          "材料图片": item.material_pic,
          "材料密度": item.material_density==null?'0':item.material_density,
          "材料标签": item.material_label,
          "材料描述": item.material_desc,
          "材料类型": item.material_type==''?'1':item.material_type.length>1?'1':item.material_type,
          "材料优点": item.material_advantage,
          "最大尺寸": item.material_max_size,
          "启用": item.material_status?'1':'0',
          "推荐": item.material_recommend?'1':'0',
          "打磨单价": item.material_polishing_price==null?'0':item.material_polishing_price,
          "克重单价": item.material_unit_price==null?'0':item.material_unit_price,
          "材料单价": item.material_base_price==null?'0':item.material_base_price,
          "精度公差": item.tolerance_precision,
          "材料附件": item.material_attachment,
          "定制信息": item.material_customize==null?'[]':item.material_customize=='null'?'[]':item.material_customize,
          "使用材料系数": item.material_use_coefficient?'1':'0',
          "材料系数配置": item.material_coefficient_config==null?'[]':item.material_coefficient_config,
          "排序": item.material_rank==null?'0':item.material_rank,
          "保底尺寸": item.material_small_longest_side,
          "保底价格": item.material_small_longest_side_price,
         
        }));
        // 生成 Excel
        const worksheet = XLSX.utils.json_to_sheet(filteredData, {
          header: ["材料分类ID", "材料名称", "材料图片", "材料密度", "材料标签", "材料描述", "材料类型", "材料优点", "最大尺寸", "启用", "推荐", "打磨单价", "克重单价", "材料单价", "精度公差", "材料附件", "定制信息", "使用材料系数", "材料系数配置", "排序", "保底尺寸", "保底价格"],
          skipEmpty: false
        });
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "材料数据");
        // 导出 Excel 文件
        XLSX.writeFile(workbook, "材料数据.xlsx");
      }
    },
    // 响应添加按钮
    async addButton() {
      this.uploadFileList=[]
      this.uploadImageList=[]
      this.formData = {}
      this.drawerData.visible = true
      this.drawerData.title = '添加数据'
      this.drawerData.loading = false
      this.formData.id = ''
    },
    addItem() {
      this.formData.material_customize.push({title:'',content:''})
    },
    deleteItem(item){
      this.formData.material_customize.splice(item,1)
    },
    getallUrl(url){
      if(url==null || url=='' || url==undefined){
        return ''
      }
      if(url.startsWith("http")){
        return url
      }else if(url.startsWith("/")){
        return window.location.origin + url
      }else{
        return window.location.origin + "/" + url
      }
    },
    // 响应编辑按钮
    async editButton(id) {
      this.uploadFileList=[]
      this.uploadImageList=[]
      this.drawerData.loading_text = '玩命加载中……'
      this.drawerData.visible = true
      this.drawerData.title = '编辑数据(UID：'+id+')'
      let res = await this.$api.post('/service/ola_app_craft_category_material/detail',{id:id})
      if (this.$apiSuccess(res)){
        this.formData = res.data.detail
        if (res.data.detail.material_pic !='' ){
          this.uploadImageList = [{url:this.getallUrl(res.data.detail.material_pic)}]
        }
        if (res.data.detail.material_attachment !='' && res.data.detail.material_attachment != null){
          this.uploadFileList = [{url:this.getallUrl(res.data.detail.material_attachment)}]
        }
        // 解析 material_customize
        if (res.data.detail.material_customize == null || res.data.detail.material_customize == '' || res.data.detail.material_customize == 'null'){
          this.formData.material_customize = [{
            title:'',
            content:''
          }]
        }else{
            this.formData.material_customize = this.parseJsonString(res.data.detail.material_customize)
          }
          
          // 解析 material_coefficient_config
          if(res.data.detail.material_coefficient_config != null && res.data.detail.material_coefficient_config != '' && res.data.detail.material_coefficient_config != 'null'){
            this.formData.material_coefficient_config = this.parseJsonString(res.data.detail.material_coefficient_config)
          }else{
            this.formData.material_coefficient_config = []
        }
      }else{
        this.$message.error(res.message)
      }
      this.drawerData.loading = false
    },
    // 处理抽屉关闭
    drawerClose() {
      this.initFormData()
      this.drawerData.visible = false
      this.drawerData.loading = true
    },
    // 处理抽屉确认
    async drawerConfirm() {
      // 调用组件的数据验证方法
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          this.formSubmit()
        } else {
          this.$message.error('数据验证失败，请检查必填项数据！')
        }
      })
    },
      // 图片上传成功回调
      handleUploadImageSuccess(file, fileList) {
        this.formData.material_pic = file
        this.uploadImageList = fileList
      },
      // 图片删除回调
      handleUploadImageRemove(file, fileList) {
        this.formData.material_pic = 0
        this.uploadImageList = fileList
      },
      // 附件上传成功回调
      handleUploadFileSuccess(file, fileList) {
        this.formData.material_attachment = file
        this.uploadFileList = fileList
      },
      // 附件删除回调
      handleUploadFileRemove(file, fileList) {
        this.formData.material_attachment = 0
        this.uploadFileList = fileList
      },
    // form数据提交，请求接口
    async formSubmit() {
      this.drawerData.loading_text = '玩命提交中……'
      this.drawerData.loading = true
      this.formData.material_customize = JSON.stringify(this.formData.material_customize)
      this.formData.material_coefficient_config = JSON.stringify(this.formData.material_coefficient_config)
      let url = '/service/ola_app_craft_category_material/create'
      if(this.formData.id != ''){
        url = '/service/ola_app_craft_category_material/update'
      }
      this.formData.craft_category_id = this.$route.params.id
      let res = await this.$api.post(url,this.formData)
      if (this.$apiSuccess(res)){
        this.$message.success('保存成功!')
        this.getMaterials()
        
      }else{
        this.$message.error(res.message)
      }
      this.drawerData.visible = false
      this.initFormData()
    },
    // row数据提交，请求接口
    async rowSubmit(row) {
      this.drawerData.loading_text = '玩命提交中……'
      this.drawerData.loading = true
      if(row.material_status=='0'){
        row.material_status='1'
      }else{
        row.material_status='0'
      }
      let id = await this.$api.modifyMaterial(row)
      this.$nextTick(() => {
        this.drawerData.visible = false
      })
      this.$nextTick(async () => {
        if (id) {
          this.getMaterial()
        }
      })
      this.$nextTick(() => {
        this.$message.success('保存成功!')
      })
      this.initFormData()
    },
    // 相应删除按钮
    async deleteButton(id) {
      let info = await this.$api.deleteMaterial(id)
      if (info == null) {
        this.$message.success('删除成功!')
        this.$nextTick(async () => {
          this.getMaterials()
        })
      } else {
        this.$message.error(info)
      }
      
    },
    // 初始化数据
    initFormData() {
      // 初始化form表单
      this.$nextTick(() => {
        this.formData = {id:0}
        this.$refs['dataForm'].resetFields()
      })
    },
    async getMaterialColor(id) {
       window.open('/craft/category/material/'+id+'/material_color', '_blank');
    },
    async getMaterialDuration(id) {
       window.open('/craft/category/material/'+id+'/material_duration', '_blank');
    },
    async getMaterialFollowCraft(id) {
       window.open('/craft/category/material/'+id+'/material_follow_craft', '_blank');
    },
    // 初始化数据列表
    async getMaterials() {
      this.setSearchCondition()
      this.loadingStaus=true
      let pagingInfo = this.$refs['apeTable'].getPagingInfo()
      Object.assign(this.searchCondition,pagingInfo)
      let res= await this.$api.post('/service/ola_app_craft_category_material/list',this.searchCondition)
      if (this.$apiSuccess(res)){
        this.dataList=res.data.list
        this.pagingData.total = res.data.page.total
        this.loadingStaus=false
      }else{
        this.$message.error(res.message)
        this.dataList=[]
        this.loadingStaus=false
      }
    },
    // 拖拽排序数据提交，请求接口
    async dragSortSubmit(orderIds) {
      let res = await this.$api.post('/service/ola_app_craft_category_material/order',{orderIds:orderIds,sort_field:'material_rank'})
      if (this.$apiSuccess(res)){
        this.$message.success('排序成功!')
        this.getMaterials()
      }else{
        this.$message.error('排序失败!')
      }
    },
    // 表格拖拽排序，同层级移动有效果
    dragSort() {
      const el = document.querySelectorAll('.el-table__body-wrapper > table > tbody')[0]
      this.sortable = Sortable.create(el,{
        handle: ".drag-handle", 
        setData: function(dataTransfer) {
          dataTransfer.setData('Text', '')
        },
        onEnd: () => {
          let Ids = []
          let tmp = el.querySelectorAll('.drag-handle')
          for (let i=0,len=tmp.length; i < len; i++) {
            Ids.push(tmp[i].dataset.id)
          }
          this.dragSortSubmit(Ids)
        },
      })
    },
  },
  mounted() {
    this.getMaterials()
    this.$nextTick(() => {
      this.dragSort()
    })
  },
}
</script>

<style lang="stylus" scoped>
  .main-page-content
    padding 24px
    min-height calc(100vh - 84px)
    background-color #f5f7fa

  // 页面标题区域
  .page-title-section
    background linear-gradient(135deg, #667eea 0%, #764ba2 100%)
    border-radius 12px
    padding 32px
    margin-bottom 24px
    color white
    box-shadow 0 8px 32px rgba(102, 126, 234, 0.15)

  .title-content
    text-align center

  .page-title
    font-size 32px
    font-weight 600
    margin 0 0 8px 0
    display flex
    align-items center
    justify-content center
    gap 12px
    
    i
      font-size 36px

  .page-subtitle
    font-size 16px
    opacity 0.9
    margin 0
    line-height 1.5

  // 操作按钮卡片
  .action-card
    background white
    border-radius 12px
    padding 20px
    margin-bottom 24px
    box-shadow 0 4px 20px rgba(0, 0, 0, 0.08)
    border 1px solid #e8ecf4

  .action-header
    margin-bottom 16px
    padding-bottom 12px
    border-bottom 2px solid #f0f2f5

  .action-title
    color #1f2937
    font-size 18px
    font-weight 600
    margin 0
    display flex
    align-items center
    gap 8px

  .action-buttons
    display flex
    flex-wrap wrap
    gap 8px

  .action-btn
    border-radius 8px
    font-weight 500
    transition all 0.3s ease
    
    &:hover
      transform translateY(-2px)
      box-shadow 0 4px 12px rgba(0, 0, 0, 0.15)

  // 搜索卡片
  .search-card
    background white
    border-radius 12px
    padding 24px
    margin-bottom 24px
    box-shadow 0 4px 20px rgba(0, 0, 0, 0.08)
    border 1px solid #e8ecf4

  .search-header
    margin-bottom 20px
    padding-bottom 12px
    border-bottom 2px solid #f0f2f5

  .search-title
    color #1f2937
    font-size 18px
    font-weight 600
    margin 0 0 4px 0
    display flex
    align-items center
    gap 8px

  .search-subtitle
    color #6b7280
    font-size 14px
    margin 0

  .search-form
    /deep/ .el-form-item
      margin-bottom 16px
      
    /deep/ .el-form-item__label
      color #374151
      font-weight 500

    /deep/ .el-input__inner
      border-radius 8px
      border 1px solid #d1d5db
      transition all 0.3s ease
      
      &:focus
        border-color #667eea
        box-shadow 0 0 0 3px rgba(102, 126, 234, 0.1)

  .search-btn
    background linear-gradient(45deg, #667eea, #764ba2)
    border none
    border-radius 8px
    padding 8px 16px
    font-weight 500
    transition all 0.3s ease
    
    &:hover
      transform translateY(-2px)
      box-shadow 0 8px 25px rgba(102, 126, 234, 0.3)

  .reset-btn
    border-radius 8px
    padding 8px 16px
    margin-left 8px
    transition all 0.3s ease
    
    &:hover
      transform translateY(-2px)

  // 表格卡片
  .table-card
    background white
    border-radius 12px
    padding 24px
    box-shadow 0 4px 20px rgba(0, 0, 0, 0.08)
    border 1px solid #e8ecf4

  .table-header
    display flex
    justify-content space-between
    align-items center
    margin-bottom 20px
    padding-bottom 12px
    border-bottom 2px solid #f0f2f5

  .header-left
    display flex
    align-items center
    gap 8px
    font-size 18px
    font-weight 600
    color #1f2937
    
    i
      color #667eea
      font-size 20px

  .header-right
    .el-tag
      border-radius 6px
      font-weight 500

  // 材料图片样式
  .material-image
    position relative
    border-radius 8px
    overflow hidden
    
    &:hover .image-overlay
      opacity 1

  .image-overlay
    position absolute
    top 0
    left 0
    right 0
    bottom 0
    background rgba(0, 0, 0, 0.5)
    display flex
    align-items center
    justify-content center
    opacity 0
    transition opacity 0.3s ease
    
    i
      color white
      font-size 20px

  // 材料信息样式
  .material-info
    .info-row
      display flex
      align-items center
      margin-bottom 6px
      font-size 12px
      
      i
        color #667eea
        margin-right 6px
        font-size 14px
        width 14px
      
      .info-label
        color #6b7280
        margin-right 4px
        font-weight 500
        min-width 60px
      
      .info-value
        color #1f2937
        font-weight 500
        
        &.price-text
          color #059669
          font-weight 600

  // 状态列样式
  .status-column
    display flex
    flex-direction column
    gap 8px

  .status-item
    display flex
    flex-direction column
    align-items center
    gap 4px

  .status-label
    font-size 11px
    color #6b7280
    font-weight 500

  // 操作按钮样式
  .action-buttons
    display flex
    gap 4px
    justify-content center

  .action-btn-mini
    border-radius 6px
    transition all 0.3s ease
    
    &:hover
      transform translateY(-1px)
      box-shadow 0 4px 12px rgba(0, 0, 0, 0.15)

  // 拖拽排序样式
  .drag-handle
    font-size 18px
    cursor move
    color #667eea
    transition all 0.3s ease
    
    &:hover
      color #4f46e5
      transform scale(1.1)

  // 表格样式优化
  /deep/ .el-table
    border-radius 8px
    overflow hidden
    
    th
      background linear-gradient(45deg, #f8fafc, #f1f5f9)
      color #374151
      font-weight 600
      border-bottom 2px solid #e5e7eb
      
    td
      border-bottom 1px solid #f3f4f6
      
    tr:hover td
      background-color #f8fafc

  /deep/ .el-pagination
    margin-top 24px
    display flex
    justify-content center

  /deep/ .el-tag
    border-radius 6px
    font-weight 500

  /deep/ .el-switch
    margin 0

  // 响应式设计
  @media (max-width: 768px)
    .main-page-content
      padding 16px
      
    .page-title-section
      padding 24px 20px
      
    .page-title
      font-size 24px
      
    .action-card, .search-card, .table-card
      padding 16px
      
    .search-form
      /deep/ .el-form-item
        display block
        margin-bottom 12px
        
    .table-header
      flex-direction column
      gap 12px
      align-items flex-start

    .action-buttons
      flex-direction column
      gap 8px

  // 表单容器样式
  .form-container
    padding 20px
    background-color #f8fafc

  .material-form
    background white
    border-radius 12px
    padding 24px
    box-shadow 0 2px 12px rgba(0, 0, 0, 0.1)

  // 表单分区样式
  .form-section
    margin-bottom 32px
    background white
    border-radius 8px
    padding 20px
    border 1px solid #e8ecf4

  .section-header
    display flex
    justify-content space-between
    align-items center
    margin-bottom 20px
    padding-bottom 12px
    border-bottom 2px solid #f0f2f5

  .section-title
    color #1f2937
    font-size 16px
    font-weight 600
    margin 0
    display flex
    align-items center
    gap 8px
    
    i
      color #667eea
      font-size 18px

  .add-custom-btn
    border-radius 6px
    font-weight 500

  // 上传区域样式
  .upload-section
    border 2px dashed #d1d5db
    border-radius 8px
    padding 20px
    text-align center
    transition all 0.3s ease
    
    &:hover
      border-color #667eea
      background-color #f8fafc

  // 定制表格样式
  .custom-table-container
    border-radius 8px
    overflow hidden
    border 1px solid #e8ecf4

  .custom-table
    /deep/ th
      background linear-gradient(45deg, #f8fafc, #f1f5f9)
      color #374151
      font-weight 600
      
    /deep/ td
      border-bottom 1px solid #f3f4f6

  .delete-btn
    border-radius 4px
    
    &:hover
      transform scale(1.05)

  // 系数配置区域样式
  .coefficient-config-section
    border 1px solid #e8ecf4
    border-radius 8px
    padding 16px
    background-color #fafbfc

  .config-header
    display flex
    justify-content space-between
    align-items center
    margin-bottom 16px
    padding-bottom 8px
    border-bottom 1px solid #e8ecf4
    
    span
      font-weight 600
      color #1f2937
      
  .add-row-btn
    border-radius 6px
    font-weight 500
    
  .delete-row-btn
    border-radius 4px
    
    &:hover
      transform scale(1.1)

  .coefficient-table
    /deep/ th
      background linear-gradient(45deg, #f8fafc, #f1f5f9)
      color #374151
      font-weight 600
      
    /deep/ td
      border-bottom 1px solid #f3f4f6
      
    /deep/ .el-input-group__append
      background-color #f5f7fa
      border-color #d1d5db
      color #374151
      font-size 12px

  // 表单项样式优化
  /deep/ .el-form-item
    margin-bottom 20px
    
    .el-form-item__label
      color #374151
      font-weight 500
      
    .el-input__inner, .el-textarea__inner
      border-radius 6px
      border 1px solid #d1d5db
      transition all 0.3s ease
      
      &:focus
        border-color #667eea
        box-shadow 0 0 0 3px rgba(102, 126, 234, 0.1)
        
    .el-input-group__append
      background-color #f5f7fa
      border-color #d1d5db
      color #374151
      border-radius 0 6px 6px 0

  /deep/ .el-select
    width 100%
    
    .el-input__inner
      border-radius 6px

  // 兼容原有样式
  .el-button
    margin-right 4px
    margin-bottom 4px
    
  .table-header
    margin-bottom 12px
    
  .el-input-group__prepend, .el-input-group__append
    background #ffffff
    padding 0 12px
    
  .el-input-group__append
    color #ffffff
    background #1890ff
    
  .el-popover .el-checkbox-group .el-checkbox
    margin-left 0px
    margin-right 12px
    
  .el-select > .el-input 
    width 120px
</style>
